import { TOOLS } from '../constants';

export const TOOLSPRACTICES = {
    category: TOOLS,
    skills: [
        {
            category: TOOLS,
            skill: 'Agile / Scrum',
            level: 9,
        },
        {
            category: TOOLS,
            skill: 'Git / GitHub',
            level: 8,
        },
        {
            category: TOOLS,
            skill: 'Pair Remote Programming',
            level: 7,
        },
        {
            category: TOOLS,
            skill: 'AWS (EC2 / Lambda / S3)',
            level: 6,
        },
        {
            category: TOOLS,
            skill: 'Testing / QA',
            level: 5,
        },
        {
            category: TOOLS,
            skill: 'Load Testing',
            level: 3,
        },
    ],
};
